import { render, staticRenderFns } from "./work-schedule.vue?vue&type=template&id=33d84880"
import script from "./work-schedule.vue?vue&type=script&lang=js"
export * from "./work-schedule.vue?vue&type=script&lang=js"
import style0 from "./work-schedule.vue?vue&type=style&index=0&id=33d84880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports